/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-05-11 10:52:12
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 超合同管控
 * @FilePath     : \icps_fb\src\api\internetSales\supplyManagement\controlSet\exceedContractControl.vue
 */
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <!-- 搜索栏 -->
                            <div class="search">
                              <span style="display: inline-block; margin-bottom: 10px">
                                <span style="margin-right: 12px">工程名称</span>
                                <el-input v-model="tableParam.projectName"
                                  style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                                  @keyup.enter.native="gettableData()" />
                              </span>
                              <span style="display: inline-block; margin-left: 12px">
                                <span style="margin-right: 12px">销售员</span>
                                <el-select
                                  v-model="tableParam.salePerson"
                                  placeholder="请选择"
                                  clearable
                                  filterable
                                  style="width: 150px"
                                >
                                  <el-option
                                    v-for="(item, index) in salesLeadsStatusList"
                                    :key="index"
                                    :label="item.saller"
                                    :value="item.saller"
                                  />
                                </el-select>
                              </span>
                              <span style="display: inline-block; margin-left: 12px">
                                <span style="margin-right: 12px">施工进度</span>
                                <el-input v-model="tableParam.supplyPhase"
                                  style="width: 150px; min-width: 100px; max-width: 200px" clearable placeholder="请输入"
                                  @keyup.enter.native="gettableData()" />
                              </span>
                              <span style="display: inline-block; margin-left: 12px">
                                <span style="margin-right: 12px">状态</span>
                                <el-select v-model="tableParam.status" style="width: 150px" clearable>
                                  <el-option label="待风控" :value="0" />
                                  <el-option label="已风控" :value="1" />
                                  <el-option label="临时解控" :value="2" />
                                </el-select>
                              </span>
                              <span style="display: inline-block; margin-left: 12px">
                                <span style="margin-right: 12px">审批状态</span>
                                <el-select v-model="tableParam.approveStatus" style="width: 150px" clearable>
                                  <el-option label="撤销" :value="0" />
                                  <el-option label="审批中" :value="1" />
                                  <el-option label="审批通过" :value="2" />
                                  <el-option label="审核失败" :value="3" />
                                </el-select>
                              </span>
                              <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                @click="(tableParam.page = 1), gettableData()">查询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div style="color: red; font-size: 16px;font-weight:400;display: flex; align-items: center;">
                                备注:累计供应量、管控状态每日9点刷新，已用额度=计有效计划量（生产但未完工的浇筑量）+ 完工生产量（已完工计划，物流的票面量，不管计划什么时候创建）。已用额度实时查询
                            </div>
                            <div>
                                <el-link :underline="false" @click="load()">
                                    <span class="el-icon--left">
                                        <i class="iconfont iconicon_button_export1"></i>
                                    </span>
                                    导出
                                </el-link>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :height="screenHeight - 425" :data="tableData"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <!-- 状态列 -->
                                            <span v-if="item.label == '状态'">
                                                <el-link v-if="scope.row.status == 0" type="danger"
                                                    :underline="false"
                                                    @click="queryExceedContractHistory(scope.row)">待风控</el-link>
                                                <el-link v-if="scope.row.status == 1" type="danger"
                                                    :underline="false"
                                                    @click="queryExceedContractHistory(scope.row)">已风控</el-link>
                                                <el-link v-if="scope.row.status == 2" type="success"
                                                    :underline="false"
                                                    @click="queryExceedContractHistory(scope.row)">临时解控</el-link>
                                            </span>
                                            <!-- 审批状态列 -->
                                            <span v-else-if="item.label == '审批状态'">
                                                <span v-if="scope.row.approveStatus == 0">撤销</span>
                                                <span v-else-if="scope.row.approveStatus == 1">审批中</span>
                                                <span v-else-if="scope.row.approveStatus == 2">审批通过</span>
                                                <span v-else-if="scope.row.approveStatus == 3">审核失败</span>
                                            </span>
                                            <!-- 管控等级 -->
                                            <span v-else-if="item.label == '管控等级'">
                                                <span v-if="scope.row.controlLevel == 1">一级管控</span>
                                                <span v-else-if="scope.row.controlLevel == 2">二级管控</span>
                                                <span v-else-if="scope.row.controlLevel == 3">三级管控</span>
                                            </span>
                                            <span v-else-if="item.label == '累计供应量'">
                                                <el-link  type="primary"  :underline="false"  @click="showSubProjectDetail(scope.row)">
                                                    {{ scope.row[item.prop] }}
                                                </el-link>
                                            </span>
                                            <span v-else-if="item.label == '操作'">
                                                <!-- 审批中-不可以展示  && scope.row.status != 0-->
                                                <el-link v-if="scope.row.approveStatus != 1  "
                                                    type="danger" :underline="false"
                                                    @click="applyRemoveControl(scope.row)">申请解控</el-link>
                                            </span>

                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
            <!-- 累计供应量弹窗 -->
            <el-dialog 
                title="项目明细" 
                :visible.sync="subProjectDialogVisible" 
                width="800px" 
                :close-on-click-modal="false"
            >
                <template v-if="currentSubProjectData && currentSubProjectData.length > 0">
                    <el-table
                        :header-cell-style="{ background: '#f3f6f9' }"
                        :cell-style="{ borderRight: 'none' }"
                        border
                        stripe
                        style="width: 100%;"
                        :data="currentSubProjectData"
                    >
                        <el-table-column label="工程id" align="center" prop="projectId" width="auto"></el-table-column>
                        <el-table-column label="工程名称" align="center" prop="projectName" width="auto"></el-table-column>
                        <el-table-column label="累计供应量（m³）" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                    </el-table>
                </template>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="subProjectDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <!-- 申请解控对话框 -->
            <el-dialog :visible.sync="removeControlDig" width="1140px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item :span="2" label="工程名称：">{{ formData.projectName }}</el-descriptions-item>
                    <el-descriptions-item label="工程ID：">{{ formData.projectId }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{formData.contractCompany}}</el-descriptions-item>
                    <el-descriptions-item label="施工进度">{{ formData.supplyPhase }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="签订主体：">{{ formData.signCompany }}</el-descriptions-item>
                    <el-descriptions-item label="销售员：">{{ formData.salePerson }}</el-descriptions-item>
                    <el-descriptions-item label="最近一次供应时间：">{{ formData.lastSupplyTime }}</el-descriptions-item>
                    <el-descriptions-item label="合同量：">{{ formData.contractQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="累计供应量（m³）">{{ formData.totalSupplyQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="申请累计供应量（m³）"  labelClassName="redFont"  contentClassName="textClass">
                        <el-input v-model="formData.controlQuantity"  placeholder="请输入数量"  style="width: 430px;" type="number"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="原因概述" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="formData.alterReason" placeholder="请输入" type="textarea"
                            style="width: 100%;">
                        </el-input>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="isLook" :files="files" @deleteFile="deleteFile"
                            @uplodeSuccess="uplodeSuccess" />
                    </el-descriptions-item> -->
                </el-descriptions>
                <span style="font-size: 18px;margin-top: 24px;">历史申请流程</span>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark" :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="updateTime" width="auto"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="updateUserName" width="auto"></el-table-column>
                    <el-table-column label="合同量" align="center" prop="contractQuantity" width="auto"></el-table-column>
                    <el-table-column label="累计供应量" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                    <el-table-column label="本次申请累计供应量（m³）" align="center" prop="controlQuantity" width="auto"></el-table-column>
                    <el-table-column label="流程完成时间" align="center" prop="approveTime" width="auto"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approveStatus" width="auto">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approveStatus == 0">撤销</span>
                            <span v-else-if="scope.row.approveStatus == 1">审批中</span>
                            <span v-else-if="scope.row.approveStatus == 2">审批通过</span>
                            <span v-else-if="scope.row.approveStatus == 3">审核失败</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="removeControlDig = false">关 闭</el-button>
                    <el-button class="bottom_all" @click="saveRemoveControl">提 交</el-button>
                </span>
            </el-dialog>

            <!-- 历史记录明细对话框 -->
            <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">申请解控详情</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200">
                    <el-descriptions-item :span="2" label="工程名称：">{{ historyDetailForm.projectName }}</el-descriptions-item>
                    <el-descriptions-item label="工程ID：">{{ historyDetailForm.projectId }}</el-descriptions-item>
                    <el-descriptions-item label="合同单位：">{{historyDetailForm.contractCompany}}</el-descriptions-item>
                    <el-descriptions-item label="施工进度">{{ historyDetailForm.supplyPhase }}</el-descriptions-item>
                    <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
                    <el-descriptions-item label="签订主体：">{{ historyDetailForm.signCompany }}</el-descriptions-item>
                    <el-descriptions-item label="销售员：">{{ historyDetailForm.salePerson }}</el-descriptions-item>
                    <el-descriptions-item label="最近一次供应时间：">{{ historyDetailForm.lastSupplyTime }}</el-descriptions-item>
                    <el-descriptions-item label="合同量：">{{ historyDetailForm.contractQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="累计供应量（m³）">{{ historyDetailForm.totalSupplyQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="本次申请累计供应量（m³）">{{ historyDetailForm.controlQuantity }}</el-descriptions-item>
                    <el-descriptions-item label="原因概述" labelClassName="redFont" contentClassName="textClass"
                        :span="2">
                        <el-input v-model="historyDetailForm.alterReason" :disabled="true" placeholder="请输入" type="textarea"
                            style="width: 100%;">
                        </el-input>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item label="附件：" :span="2">
                        <FileComponent fileCode="settlementFile" :disabled="true" :files="files2"  />
                    </el-descriptions-item> -->
                </el-descriptions>
                <!-- 项目明细表格 -->
                <template v-if="subProjectInfoTableData && subProjectInfoTableData.length > 0">
                    <el-table
                        :header-cell-style="{ background: '#f3f6f9' }"
                        :cell-style="{ borderRight: 'none' }"
                        border
                        stripe
                        style="width: 100%; margin-top: 12px;"
                        :data="subProjectInfoTableData"
                    >
                        <el-table-column label="工程id" align="center" prop="projectId" width="auto"></el-table-column>
                        <el-table-column label="工程名称" align="center" prop="projectName" width="auto"></el-table-column>
                        <el-table-column label="累计供应量（m³）" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                    </el-table>
                </template>
                <span style="font-size: 18px">领导审批参数</span>
                <el-descriptions :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                    <el-descriptions-item label="本次申请累计供应量（m³）" labelClassName="redFont">{{
                        historyDetailForm.alterValue }}
                    </el-descriptions-item>
                </el-descriptions>
                <FlowsNodeList :tableData="approveTableData" />
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                </span>
            </el-dialog>

            <!-- 历史记录列表对话框 -->
            <el-dialog title="历史记录" :visible.sync="historyDig" width="1140px">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%;margin-top: 12px;" tooltip-effect="dark" :data="removeControlTableData">
                    <el-table-column label="申请时间" align="center" prop="updateTime" width="auto"></el-table-column>
                    <el-table-column label="申请人" align="center" prop="updateUserName" width="auto"></el-table-column>
                    <el-table-column label="合同量" align="center" prop="contractQuantity" width="auto"></el-table-column>
                    <el-table-column label="累计供应量" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                    <el-table-column label="本次申请累计供应量（m³）" align="center" prop="alterValue" width="auto"></el-table-column>
                    <el-table-column label="流程完成时间" align="center" prop="approveTime" width="auto"></el-table-column>
                    <el-table-column label="审批状态" align="center" prop="approveStatus" width="auto">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approveStatus == 0">撤销</span>
                            <span v-else-if="scope.row.approveStatus == 1">审批中</span>
                            <span v-else-if="scope.row.approveStatus == 2">审批通过</span>
                            <span v-else-if="scope.row.approveStatus == 3">审核失败</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left" width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="historyDig = false">关 闭</el-button>
                </span>
            </el-dialog>
            <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { exceedContractQuery,  queryExceedContractHistory, exceedContractDownload as Download  } from "@/api/internetSales/supplyManagement.js";
import { querySales } from "@/api/internetSales/monthlyReportUnitRecord.js";
// import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
import { getNodeList } from '@/api/task/flows';
import LookFile from "@/components/File/LookFile";
import { getUserInfo } from "@/utils/auth.js";

export default {
    components: {
        // FileComponent,
        FlowsNodeList,
        LookFile
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "工程ID", prop: "projectId", status: true, width: "180", fixed: "left" },
                { label: "工程名称", prop: "projectName", status: true, width: "280", fixed: "left" },
                { label: "合同单位", prop: "contractCompany", status: true, width: "220" },
                { label: "签订主体", prop: "signCompany", status: true, width: "160" },
                { label: "协调主体", prop: "coordinationSubject", status: true, width: "160" },
                { label: "施工进度", prop: "supplyPhase", status: true, width: "120" },
                { label: "交底类型", prop: "discloseType", status: true, width: "120" },
                { label: "最近一次供应时间", prop: "lastSupplyTime", status: true, width: "120" },
                { label: "合同量", prop: "contractQuantity", status: true, width: "120" },
                { label: "累计供应量", prop: "totalSupplyQuantity", status: true, width: "100" },
                { label: "管控量", prop: "controlQuantity", status: true, width: "100" },
                { label: "已用额度", prop: "usedAmount", status: true, width: "100" },
                { label: "销售员", prop: "salePerson", status: true, width: "100" },
                { label: "管控等级", prop: "controlLevel", status: true, width: "120" },
                { label: "状态", prop: "status", status: true, width: "120" },
                { label: "审批状态", prop: "approveStatus", status: true, width: "120" },
                { label: "审批时间", prop: "approveTime", status: true, width: "150" },
                { label: "操作", prop: "", status: true, width: "120" }
            ],
            DownloadURL: Download,
            tableData: [],
            pagesType: 0,
            tableParam: {
              page: 1,
              pageSize: 10,
              dataType: 1,
              projectName: "",
              salePerson: "",
              supplyPhase: "",
              approveStatus: "",
              status: "",
            },
            formData: {
              approveStatus: 0,
              approveTime: "",
              company: "",
              companyId: "",
              contractCompany: "",
              contractQuantity: 0,
              controlLevel: 0,
              controlQuantity: 0,
              coordinationSubject: "",
              createTime: "",
              discloseType: "",
              endData: 0,
              exceedContractProjectHistoryList: [],
              financialCode: "",
              historyId: "",
              id: "",                      
              mainId: "",                      
              alterValue: "",                      
              isMainEngineering: 0,
              lastSupplyTime: "",
              page: 0,
              pageSize: 0,
              projectId: "",
              projectName: "",
              salePerson: "",
              salePersonId: "",
              signCompany: "",
              sortProperty: "",
              sortType: "",
              startData: 0,
              status: 0,
              subProjectInfo: "",
              supplyPhase: "",
              totalSupplyQuantity: 0,
              updateTime: "",
              updateUserId: "",
              updateUserName: "",
              warningSms: 0
            },
            historyDetailForm: {},
            files: [],
            files2: [],
            confirmFiles: [], // 保留以防其他地方引用，虽然确认弹窗已删
            isLook: false,
            removeControlDig: false,
            historyDetailDig: false,
            subProjectDialogVisible: false,
            low: {},
            approveTableData: [],
            userRealName: "",
            removeControlTableData: [],
            subProjectInfoTableData: [],
            currentSubProjectData: [],//累计供应展示
            salesLeadsStatusList: [],
            historyDig: false,
            dataType: 1,
            lookFileVisible: false,
            lookFileConfig: { filePaths: "" },
        };
    },
    async created() {
        this.tableParam.salePerson = await getUserInfo().userRealName;
        this.gettableData(true);
        querySales().then(res => {
            if (res.code == 1001) {
              this.salesLeadsStatusList = res.data;
            }
        });
    },
    methods: {
        lookFile(row) {
            this.lookFileConfig.filePaths = row.attachment
            this.lookFileVisible = true
        },
        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            // this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approveStatus: item.approveStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;

                }
            });
            this.historyDetailDig = true
        },
        saveRemoveControl() {
            console.log("-----------------this.formData----------------")
            console.log(this.formData)
            if(this.formData.controlQuantity == null || this.formData.controlQuantity == ""){
                this.$message.error("请填写本次申请累计供应量！")
                return
            }
            if (Number(this.formData.controlQuantity) <= Number(this.formData.totalSupplyQuantity)) {
                this.$message.error("本次申请累计供应量必须大于累计供应量！");
                return;
            }
            if(this.formData.alterReason == null || this.formData.alterReason == ""){
                this.$message.error("请填写原因概述！")
                return
            }
            // this.formData.attachment = JSON.stringify(this.files);
            this.$router.push({
                name: "ExceedContractApproval",
                query: {
                    formData: JSON.stringify(this.formData),
                    dataContent: JSON.stringify(this.formData),
                    type: 1,
                }
            })
        },
        uplodeSuccess(data) {
            const params = {
                fileName: data.fileName,
                filePath: data.fileUrl,
            };
            this.files.push(params);
            this.formData.attachment = JSON.stringify(this.files);
        },
        deleteFile(index) {
            this.files.splice(index, 1);
            this.formData.attachment = JSON.stringify(this.files);
        },
        gettableData() {
            exceedContractQuery(this.tableParam).then(res => {
                if (res.code == 1001) {
                    this.total = res.data.total
                    this.tableData = res.data.records
                }
            })
        },
        // 供应管控
        showSubProjectDetail(row){
            queryExceedContractHistory(row.id).then(res => {
                if (res.code == 1001) {
                    this.currentSubProjectData  =  res.data.subProjectInfo ? JSON.parse(res.data.subProjectInfo) : []
                    this.subProjectDialogVisible = true
                }
            })
        },
        //申请解控-转存id
        applyRemoveControl(row) {
            console.log('row', row)
            const initialFormData = this.$options.data().formData;
            queryExceedContractHistory(row.id).then(res => {
                if (res.code == 1001) {
                    this.removeControlTableData = res.data.exceedContractProjectHistoryList || [];
                    this.subProjectInfoTableData = res.data.subProjectInfo ? JSON.parse(res.data.subProjectInfo) : []
                    this.low = JSON.parse(JSON.stringify(row));
                    this.formData = {
                        ...initialFormData,
                        ...this.low
                    };
                    this.formData.id = res.data.historyId;
                    this.formData.mainId = res.data.id;
                    // 打开这个默认空
                    this.formData.controlQuantity = null
                    // if (this.formData.attachment) {
                    //     this.files = JSON.parse(this.formData.attachment);
                    // } else {
                    //     this.files = [];
                    // }
                    this.removeControlDig = true;
                    console.log('Final formData:', this.formData);
                }
            })
        },
        queryExceedContractHistory(row) {
            queryExceedContractHistory(row.id).then(res => {
                if (res.code == 1001) {
                    this.formData = JSON.parse(JSON.stringify(row))
                    this.low = JSON.parse(JSON.stringify(row))
                    this.removeControlTableData = res.data.exceedContractProjectHistoryList
                    this.subProjectInfoTableData =  res.data.subProjectInfo ? JSON.parse(res.data.subProjectInfo) : []
                    this.historyDig = true
                }
            })
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}
</style>